import { type FC } from "react";
import { useTranslation } from "@privacy/translations";
import { useForm } from "react-hook-form";
import type { UpdateSystemPayload } from "../../../api/systems.types";
import { useUpdateSystem } from "../../../api/systems";
import * as FormDialog from "../../../shared/FormDialog";

type SystemEditDialogProps = { onClose: () => void; systemId: string; systemName: string };

export const SystemEditDialog: FC<SystemEditDialogProps> = ({ onClose, systemId, systemName }) => {
  const { t } = useTranslation();
  const { handleSubmit, control, setFocus } = useForm<UpdateSystemPayload>({
    defaultValues: { name: systemName },
  });
  const { mutate: updateSystem, isError, isPending } = useUpdateSystem();

  FormDialog.useAutoFocusField(setFocus, "name");

  const handleUpdateSystem = (payload: UpdateSystemPayload) => {
    updateSystem({ systemId, payload }, { onSuccess: () => onClose() });
  };

  return (
    <FormDialog.Dialog isOpen={true}>
      <FormDialog.Title>{t("SystemsDrawer.Edit.DialogHeader")}</FormDialog.Title>
      <FormDialog.Form onSubmit={handleSubmit(handleUpdateSystem)}>
        <FormDialog.Content>
          <FormDialog.FormError isError={isError} />
          <FormDialog.Fields>
            <FormDialog.TextField
              control={control}
              name="name"
              rules={{ required: t("SystemsDrawer.Edit.Error") }}
              label={t("SystemsDrawer.Edit.NameLabel")}
              placeholder={t("CreateSystem.Dialog.NamePlaceholder")}
            />
          </FormDialog.Fields>
        </FormDialog.Content>

        <FormDialog.ActionButtons>
          <FormDialog.CancelButton onClick={onClose} />
          <FormDialog.SubmitButton isSubmitting={isPending}>
            {t("SystemsDrawer.Edit.SubmitButton")}
          </FormDialog.SubmitButton>
        </FormDialog.ActionButtons>
      </FormDialog.Form>
    </FormDialog.Dialog>
  );
};
